import { useMemo } from 'react';

import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import TextInput from 'src/components/TextInput';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { getBgColor, getIcon } from 'src/utils/icons';

const DeliveryDriver = () => {
  const { updateFormData, errors, receiptData, isInProgress } = useReceiptDetails();
  const data = receiptData.deliveryDriverName || '';
  const hasError = useMemo(
    () => !!errors.deliveryDriverName.length,
    [errors.deliveryDriverName.length]
  );

  return (
    <PopUp
      show={hasError}
      popupAlign={{ horizontal: 'left', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'left', vertical: 'center' }}
      content={<PopUpContentWrapper contents={errors.deliveryDriverName} type="Error" />}
    >
      <div className={`p-1 ${getBgColor(errors.deliveryDriverName)}`} title={data}>
        <div className="font-bold pb-1 flex flex-row text-[13px]">
          <p className="flex justify-center items-center">
            Delivery Driver Name
            <span className=" px-2">{getIcon(errors.deliveryDriverName)}</span>
          </p>
        </div>
        {isInProgress ? (
          <TextInput
            value={data}
            onChange={(e) => {
              updateFormData('deliveryDriverName', e.value);
            }}
            type="text"
            className="mt-1"
          />
        ) : (
          <p className="pl-1">{data}</p>
        )}
      </div>
    </PopUp>
  );
};

export default DeliveryDriver;
